import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import ProfileForm from './ProfileForm';
import ProfileFormConnections from './ProfileFormConnections';
import ProfileFormSecurity from './ProfileFormSecurity';
import { pageHeaderSX } from '../utilities/CSS';
import ProfileFormCommunication from './ProfileFormCommunication';
import CustomTabs, { CustomTabPanel } from './CustomTabs';
import { iUser } from '../contexts/UserContext';
import { iUserDTO } from '../utilities/APIInterfaces';
import { UserType } from '../contexts/AdminUsersDataContext';
import { TabProps } from '@mui/material';

export type DashboardCenterSettingsProps = {
  user: iUser | null | undefined;
  updateUser: (user:iUserDTO) => void;
  isAdminEdit: boolean;
  selectedUserType: UserType | null;
  isReadOnly: boolean;
}
export default function DashboardCenterSettings(props: DashboardCenterSettingsProps) {
  const [tabs, setTabs] = useState<TabProps[]>([]);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newTab: number) => {
    setSelectedTab(newTab);
  };

  useEffect(() => {
    let tab: TabProps[]
    if (props.selectedUserType === "Institution") {
      tab = [
        { label: 'My Account' },
        { label: 'Security' }
      ];
    } else {
      tab = [
        { label: 'My Account' },
        { label: "Contributors"},
        { label: 'Communication' },
        { label: 'Security' }
      ];
    }
    setTabs(tab);
  }, [props.selectedUserType]);

  return (
    <>
      {props.selectedUserType !== 'Institution' && <Typography variant='h1' sx={{ ...pageHeaderSX, mb: 4.5 }}>{props.isAdminEdit ? "Student Profile" : "Settings"}</Typography>}
      {props.selectedUserType === 'Institution' && <Typography variant='h1' sx={{ ...pageHeaderSX, mb: 4.5 }}>{props.isAdminEdit ? "Institution User Profile" : "Settings"}</Typography>}

      <CustomTabs
        ariaTabAndPanelPrefix='settings'
        aria-label='Settings Tabs'
        allowScrollButtonsMobile
        selectedTab={selectedTab}
        variant='scrollable'
        tabs={tabs}
        handleTabChange={handleTabChange}
      />
      <CustomTabPanel index={0} selectedTab={selectedTab}>
        <ProfileForm isAdminEdit={props.isAdminEdit} user={props.user} updateUser={props.updateUser} selectedUserType={props.selectedUserType} isReadOnly={props.isReadOnly}/>
      </CustomTabPanel>
      {props.selectedUserType === 'Students' && <CustomTabPanel index={1} selectedTab={selectedTab}>
        <ProfileFormConnections isAdminEdit={props.isAdminEdit} user={props.user} updateUser={props.updateUser} />
      </CustomTabPanel>}
      {props.selectedUserType === 'Students' && <CustomTabPanel index={2} selectedTab={selectedTab} autoHeight>
        <ProfileFormCommunication isAdminEdit={props.isAdminEdit} user={props.user} updateUser={props.updateUser}  />
      </CustomTabPanel>}
      <CustomTabPanel index={props.selectedUserType === 'Institution' ? 1 : 3} selectedTab={selectedTab}>
        <ProfileFormSecurity isAdminEdit={props.isAdminEdit} user={props.user} updateUser={props.updateUser} isReadOnly={props.isReadOnly}/>
      </CustomTabPanel>
    </>
  );
}
